import moment from 'moment-timezone';

/**
 * Format a datetime string based on timezone, returning time/date/datetime with GMT offset and abbreviation.
 *
 * @param {string} datetime - UTC datetime string (e.g., "2025-06-06 14:30:00")
 * @param {object} timezone - Timezone object { name, utc_offset, abbreviation }
 * @param {string} type - 'time' | 'date' | 'datetime'
 * @returns {string}
 */
function formatDateTimeByTimezone(datetime, timezone = {}, type = 'datetime', convert = true) {
  const { name = 'UTC', utc_offset = '', abbreviation = '' } = timezone;
  let momentTime = moment(datetime);
  if(convert){
    momentTime = moment.utc(datetime).tz(name);
  } 

  const gmtInfo = `GMT${utc_offset}`;
  const zoneInfo = abbreviation ? `(${abbreviation} / ${gmtInfo})` : `(${gmtInfo})`;

  switch (type) {
    case 'date':
      return momentTime.format('MMM D, YYYY');
    case 'time':
      return `${momentTime.format('hh:mm A')} ${zoneInfo}`;
    case 'datetime':
    default:
      return `${momentTime.format('MMM D, YYYY hh:mm A')} ${zoneInfo}`;
  }
}

export default formatDateTimeByTimezone;
